import React, { FC, ReactNode } from "react";

import { StyledCamelTop } from "./CamelTop.styled";

type Props = {
    children: ReactNode;
};

const CamelTop: FC<Props> = ({ children }: Props) => (
    <StyledCamelTop>{children}</StyledCamelTop>
);

export default CamelTop;
